import React from 'react';
import styled, { css } from 'styled-components';
import { LayoutBox, LayoutBoxProps } from 'src/kit';

export type TooltipProps = LayoutBoxProps & {
  children: React.ReactNode;
  placement?: 'top' | 'bottom';
};

const Tooltip = ({ children, placement = 'top', ...styledProps }: TooltipProps) => (
  <TooltipContainer placement={placement}>
    <TooltipBody {...styledProps}>{children}</TooltipBody>
    <TooltipArrow />
  </TooltipContainer>
);

const TooltipArrow = styled.div`
  position: absolute;
  left: 50%;
  margin-left: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
`;

const TooltipContainer = styled.div<{ placement: TooltipProps['placement'] }>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  ${props => (props.placement === 'top' ? arrowTopPlacementStyles : arrowBottomPlacementStyles)};
`;

const arrowTopPlacementStyles = css`
  top: -35px;
  ${TooltipArrow} {
    bottom: -5px;
    border-top: 5px solid #000;
  }
`;

const arrowBottomPlacementStyles = css`
  top: 35px;
  ${TooltipArrow} {
    top: -5px;
    border-bottom: 5px solid #000;
  }
`;

const TooltipBody = styled(LayoutBox)`
  padding: 3px 8px;
  color: #ffffff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
  font-size: 12px;
`;

export default Tooltip;
